import axios from 'axios';

const tryImportingResults = (promoId, file, draw, setLoading, setErrorImport, setSuccessImport) => {
    if (!file) {
        setErrorImport([{ row: 1, message: 'Arquivo obrigatório.' }]);
        setSuccessImport('');
        return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sorteio_id', Number(draw));
    axios
        .post(`${process.env.REACT_APP_API_URL}/admin/resultados?promo_id=${promoId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('adminAccessToken')}`
            },
        })
        .then((response) => {
            setLoading(false);
            setSuccessImport(`${response.data.result.success_count} itens importados com sucesso.`);
            setErrorImport(response.data.result.errors);
        })
        .catch((err) => {
            setLoading(false);
            setSuccessImport('');
            if (err.response.data.result?.errors) {
                setErrorImport(err.response.data.result.errors);
            } else {
                setErrorImport([{ row: 1, message: err.response.data.message }]);    
            }
        })
}

export default tryImportingResults;